// Only an opaque notification is shared. Credentials/tokens are never stored here.
export const SESSION_EVENT = 'sport-intelligence-session-change';
export const SESSION_STORAGE_KEY = 'sport-intelligence-session-change';

export function notifySessionChanged() {
  window.dispatchEvent(new Event(SESSION_EVENT));
  try {
    localStorage.setItem(SESSION_STORAGE_KEY, `${Date.now()}-${Math.random()}`);
  } catch {
    // Storage-disabled browsers still revalidate on focus, navigation and polling.
  }
}